import { observable, action } from "mobx";
import axios from "axios";

export default class CardListaStore {

    @observable lista;
    @observable showExtras;
    @observable selectedCount;


    constructor(tabelaStore) {
        this.tabelaStore = tabelaStore;
        this.lista = [];
        this.showExtras = [];
        this.selectedCount = 0;
    }

    deselectAll(listaAtual, keyField) {
        this.lista = listaAtual;
        this.tabelaStore.onSelectAll(false, this.lista, keyField)
    }

    toggleExtras(index) {
        if(!this.isSelected(index)){
            this.lista[index].showExtras = !this.lista[index].showExtras;
        }
    }

    isSelected(index) {
        return this.lista[index].isSelected;
    }
}
